export default [
  {
    label: "Mpesa",
    value: "Mpesa",
  },
  {
    label: "Card",
    value: "Card",
  },
  {
    label: "Token",
    value: "Token",
  },
  {
    label: "Airtel",
    value: "Airtel",
  },
];
